import { type DeepPartial } from 'ts-essentials';

import { type NetworkTheming } from 'hb-react/types';
import { FONT_TYPES } from 'hb-react/types/fonts';

export const getIsCustomFont = (networkTheming: DeepPartial<NetworkTheming>) =>
  networkTheming?.global?.font_type === FONT_TYPES.CUSTOM;
